<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title"><span style="white-space: nowrap">{{ $t('words.channel_list') }}</span><span class="page-header-breadcrumb">></span><span class="channel__view__title" v-tooltip="{ content: channel.title, html:false }">{{ channel.title }}</span></h3>
                    <div class="page-header-action-group" v-if="isOnAir"><i class="icon icon-time"></i><span class="page__header__live__time">{{ broadcastDuration }}</span></div>
                </div>
            </div>

            <div class="page-module">
                <div class="row">
                    <div class="col-md-6">
                        <component playerId="liveVideoPlayer"
                                   ref="liveVideoPlayer"
                                   :is="liveVideoPlayerComponent"
                                   :mediainfo="channel"
                                   :broadcastStatus="broadcastStatus"
                                   :isShowSnapshotImage="showSnapshotImage">
                        </component>
                    </div>
                    <div class="col-md-6">
                        <div class="channel__tab">
                            <ul class="nav nav-tab" id="childTab" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" id="live-nav" data-toggle="tab" href="#live-tab" role="tab" aria-controls="live" aria-selected="true">{{ $t('words.live_info') }}</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" id="syndication-nav" data-toggle="tab" href="#syndication-tab" role="tab" aria-controls="syndication" aria-selected="false">{{ $t('words.syndication') }}</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" id="decoration-nav" data-toggle="tab" href="#decoration-tab" role="tab" aria-controls="decoration" aria-selected="false">{{ $t('words.poster') }}/{{ $t('words.snapshot') }}</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" id="channelInfo-nav" data-toggle="tab" href="#channelInfo-tab" role="tab" aria-controls="channelInfo" aria-selected="false">{{ $t('words.channel_info') }}</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" id="chatting-nav" data-toggle="tab" href="#chatting-tab" role="tab" aria-controls="chatting" aria-selected="false">{{ $t('words.chatting') }}</a>
                                </li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="live-tab" role="tabpanel" aria-labelledby="creator-tab">
                                    <tab-live :channel="channel" v-on:changeChannel="doChangeChannel"></tab-live>
                                </div>
                                <div class="tab-pane mt-2" id="syndication-tab" role="tabpanel" aria-labelledby="syndication-tab">
                                    <tab-syndication :channel="channel" v-on:changeChannel="doChangeChannel"></tab-syndication>
                                </div>
                                <div class="tab-pane mt-2" id="decoration-tab" role="tabpanel" aria-labelledby="decoration-tab">
                                    <tab-poster-snapshot :channel="channel" v-on:showSnapshot="doShowSnapshot" v-on:changeChannel="doChangeChannel"></tab-poster-snapshot>
                                </div>
                                <div class="tab-pane mt-2" id="channelInfo-tab" role="tabpanel" aria-labelledby="channelInfo-tab">
                                    <tab-channel-info :channel="channel" v-on:changeChannel="doChangeChannel"></tab-channel-info>
                                </div>
                                <div class="tab-pane mt-2" id="chatting-tab" role="tabpanel" aria-labelledby="chatting-tab">
                                    <kollus-chatting :caller="'channel'"
                                                     :chatting_available="chattingAvailable"
                                                     :chatting_type="chattingType"
                                                     :chatting_started="chattingStartedDate"
                                                     :chatting_status="chattingRoomStatus"
                                                     :channel="channel">
                                    </kollus-chatting>
<!--                                    <div v-else class="form-guide-box is-center">-->
<!--                                        <svg width="62px" height="59px" viewBox="0 0 62 59" class="form-guide-icon">-->
<!--                                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">-->
<!--                                                <g id="icon-chat" transform="translate(1.000000, 1.000000)" stroke="#228be6" stroke-width="2">-->
<!--                                                    <path d="M25.001,47.911 C28.711,50.453 33.615,52 39,52 C41.403,52 43.702,51.677 45.852,51.111 L54,56 L54,47.187 C57.708,44.302 60,40.356 60,36 C60,33.876 59.455,31.851 58.468,29.999" id="Path"></path>-->
<!--                                                    <path d="M27,0 C12.088,0 0,9.402 0,21 C0,25.997 2.253,30.58 6,34.186 L6,48 L19.626,41.187 C21.973,41.705 24.44,42 27,42 C41.912,42 54,32.598 54,21 C54,9.402 41.912,0 27,0 Z" id="Path"></path>-->
<!--                                                    <path d="M13,16 L41,16" id="Path"></path>-->
<!--                                                    <path d="M13,27 L29,27" id="Path"></path>-->
<!--                                                </g>-->
<!--                                            </g>-->
<!--                                        </svg>-->
<!--                                        <p class="form-guide mb-1"><i class="icon icon-info-circle-line"></i>{{ $t('paragraphs.chatting_not_available_desc1')}}</p>-->
<!--                                        <p>{{ $t('paragraphs.chatting_not_available_desc2')}} {{ $t('paragraphs.chatting_not_available_desc3')}}</p>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="module" v-if="useRecordingFilePolicy">
                <div class="module-body paragraph__wrap">
                    <p class="paragraph" v-if="duplicateRecordingState==='stopped'">
                        {{ $t('paragraphs.duplicate_recording_tip1')}}<br>
                        {{ $t('paragraphs.duplicate_recording_tip2')}}<br>
                        {{ $t('paragraphs.duplicate_recording_tip3')}}
                    </p>
                    <p class="paragraph" v-else>
                        {{ $t('words.duplicate_recording_ing')}}<br>
                        {{ $t('paragraphs.duplicate_recording_ing_tip')}}<br>
                    </p>
                    <div class="paragraph__action">
                        <button class="btn btn-lg btn-primary mr-auto"
                                @click.prevent="changeDuplicateRecordingState"
                                :class="duplicateRecordingState === 'started' ?'btn-danger' :''"
                                :disabled="!isOnAir|| (duplicateRecordingState==='ing')"
                        >
                            {{ (duplicateRecordingState === 'stopped')?$t('words.recording_start'):$t('words.recording_stop') }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="module" v-if="isOnAir">
                <!--<div class="module-header">-->
                    <!--<h5 class="module-title"></h5>-->
                <!--</div>-->
                <div :class="{'module-body': true, 'chart_loading': realTimeData.loading}" id="chartModal">
                    <!--<select id="date_interval" v-model="requestInterval">-->
                        <!--<option v-for="value in intervals" :value="value" :key="value">{{ value }}</option>-->
                    <!--</select>-->
                    <div class="float-right" v-if="realTimeData.created">{{ renderRealTimeChartUpdate(realTimeData.created) }}</div>
                    <div class="clearfix"></div>
                    <real-time-chart :chartData="realTimeData" :interval="realTimeInterval" :created="realTimeData.created" :height="400" :width="getChartWidth"></real-time-chart>
                </div>
            </div>
            <broadcasts ref="broadcasts"
                        :channel="channel"
                        :caller="'channel'"
                        :chatting_available="chattingAvailable"
                        :chatting_type="chattingType"
                        @playBroadcast="showPlayerBroadcast" > </broadcasts>
            <div class="modal fade" id="playerModal" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                [{{broadcast.title}}]
                                <span v-if="recordingKind==='segment'">{{ $t('words.auto_recording_files_viewer') }}</span>
                                <span v-else>{{ $t('words.manual_recording_files_viewer') }}</span>
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="icon icon-close" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div class="modal-body modal-player" v-if="isPlayerModalOpen">
                            <section class="row">
                                <section class="col-xl-8">
                                    <component playerId="broadcastVideoPlayer"
                                               ref="broadcastVideoPlayer"
                                               :is="broadcastVideoPlayerComponent"
                                               :mediainfo="playingFiles"
                                               :playingFile.sync="playingFile"
                                    >
                                    </component>
                                </section>
                                <section class="col-xl-4">
                                    <div class="rec-playlist">
                                        <h3 class="rec-playlist__title">
                                            <span v-if="recordingKind==='segment'">{{ $t('words.auto_recording_file')}}</span>
                                            <span v-else-if="recordingKind==='duplicate'">{{ $t('words.manual_recording_file')}}</span>
                                            ({{recordingFiles.length}})
                                        </h3>
                                        <table class="table table__rec-playlist">
                                            <tbody>
                                            <tr v-for="(recordingFile, index) in recordingFiles"
                                                :key="recordingFile.id"
                                                :class="{'rec-playing':recordingFile === playingFile}"
                                            >
                                                <td @click="playRecordingFile(recordingFile)" class="rec-playlist__index">
                                                    {{index+1}}
                                                </td>
                                                <td @click="playRecordingFile(recordingFile)">
                                                    <span>{{ recordingFile.started_at | renderDateTime }}</span>
                                                    <span>{{ recordingFile.ended_at | renderDateTime }}</span>
                                                </td>
                                                <td class="cell--number">
                                                    <span v-if="index===0">(GiB)</span>
                                                    <span class="filesize" v-if="recordingFile.filesize > 0">
                                                    {{ getHumanReadableFilesize(recordingFile.filesize) }}
                                                    </span>
                                                </td>
                                                <td class="cell--action">
                                                    <a class="btn-icon-xs" :href="doDownloadRecordingFile(recordingFile)"><i class="icon icon-download"></i></a>
                                                    <a class="btn-icon-xs" @click.prevent="doDestroyRecordingFile(recordingFile)"><i class="icon icon-trash"></i></a></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </section>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';
import ChannelStatusMixin from '../../mixin/ChannelStatusMixin';
import TabLive from './TabLive.vue';
import TabInfo from './TabInfo.vue';
import TabSyndication from './TabSyndicationInfo.vue';
import TabPosterSnapshot from './TabPosterSnapshot.vue';
import RealTimeChart from '../chart/RealTimeChart';
import videoPlayer from '../videoPlayer/VideoPlayer.vue';
import BroadcastStatus from '../videoPlayer/const/BroadcastStatus';
import Broadcasts from './Broadcasts';
import Echo from 'laravel-echo';
import KollusChatting from './KollusChatting';
import ChannelConfig from './ChannelConfig';

export default {
    mixins: [
        GlobalConfigMixin,
        ChannelStatusMixin,
    ],
    components: {
        tabLive: TabLive,
        tabSyndication: TabSyndication,
        tabPosterSnapshot: TabPosterSnapshot,
        tabChannelInfo: TabInfo,
        vueVideoPlayer: videoPlayer,
        RealTimeChart,
        Broadcasts,
        KollusChatting,
    },
    props: {
        channel_id: {
            type: [String, Number],
            require: true,
        },
    },
    data() {
        return {
            channel: {},
            broadcast: {},
            // meta: {},
            duplicateRecordingState: 'stopped',
            broadcastStatus: BroadcastStatus.STOPPED,
            broadcastDuration: '',
            liveVideoPlayerComponent: '',
            broadcastVideoPlayerComponent: '',
            playerOptions: {},
            classRoom: {
                users: 0,
            },
            isPlayerModalOpen: false,
            showSnapshotImage: false,
            isRender: false,
            realTimeInterval: '5m',
            realTimeData: {
                loading: false,
                labels: null,
                results: {
                    count: {},
                    accUser: {},
                    curUser: {},
                    traffic: {},
                },
                created: null,
            },
            recordingKind: '',
            recordingFiles: null,
            playingFiles: null,
            playingFile: null,
            chattingRoomStatus: '',
            durationRepeat: null,
        };
    },
    mounted() {
        $('#childTab').tab();

        $('#childTab').on('shown.bs.tab', (event) => {
            let targetId = event.target.id;
            if (targetId === 'chatting-nav') {
                $('.tab-content').addClass('is-chatting');
            } else {
                $('.tab-content').removeClass('is-chatting');
            }
        });

        $('#playerModal').on('hidden.bs.modal', () => {
            if (this.liveVideoPlayer) this.liveVideoPlayer.muted(this.$store.state.player_snapshot.muted);

            this.broadcastVideoPlayerComponent = '';
            this.isPlayerModalOpen = false;
        });
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    beforeDestroy() {
        window.Echo.leave(`legacy-channel.${this.channel.id}`);
    },
    methods: {
        initialize() {
            this.global_reload_path = 'cms-channels-list';
            this.loadChannel();
        },
        initializePusherListener() {
            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: this.getPusher.app_key,
                cluster: this.getPusher.app_cluster,
                encrypted: false,
            });

            logger.warn(`Echo channel : legacy-channel.${this.channel.id}`);
            window.Echo.private(`legacy-channel.${this.channel_id}`)
                .listen('.broadcast.stopped', (e) => {
                    this.channel = e.data.liveMediaChannel;
                    this.$refs.broadcasts.load();
                    this.broadcastStatus = BroadcastStatus.STOPPED;
                    logger.warn('broadcast.stopped', e);
                })
                .listen('.broadcast.started', (e) => {
                    this.channel = e.data.liveMediaChannel;
                    this.broadcastStatus = BroadcastStatus.STARTED;
                    this.$refs.broadcasts.load();
                    logger.warn('broadcast.started', e);
                })
                .listen('.broadcast.resumed', (e) => {
                    this.channel = e.data.liveMediaChannel;
                    this.broadcastStatus = BroadcastStatus.RESUMED;
                    this.$refs.broadcasts.load();
                    logger.warn('broadcast.resumed', e);
                })
                .listen('.broadcast.paused', (e) => {
                    this.channel = e.data.liveMediaChannel;
                    this.broadcastStatus = BroadcastStatus.PAUSED;
                    this.$refs.broadcasts.load();
                    logger.warn('broadcast.paused', e);
                })
                .listen('.chatting-room.created', (e) => {
                    this.channel = e.data.liveMediaChannel;
                    this.chattingRoomStatus = 'created';
                    logger.warn('chatting-room.created', e);
                })
                .listen('.chatting-room.deleted', (e) => {
                    this.channel = e.data.liveMediaChannel;
                    this.chattingRoomStatus = 'deleted';
                    logger.warn('chatting-room.deleted', e);
                })
                .listen('.realtime-chart.updated', (e) => {
                    if (this.isOnAir) {
                        // this.channel = e.data.liveMediaChannel;
                        this.getRealTimeChartUpdated(e.data.chartData);
                        logger.warn('realTime-chart.updated', e);
                    }
                })
                .listen('.duplicate-recording.started', (e) => {
                    this.channel = e.data.liveMediaChannel;
                })
                .listen('.duplicate-recording.stopped', (e) => {
                    this.channel = e.data.liveMediaChannel;
                });
        },
        initializeChannel() {
            if (this.isOnAir) {
                this.loadChart();
            }
        },
        doChangeChannel(channel) {
            this.channel = channel;
        },
        doShowSnapshot() {
            this.showSnapshotImage = !this.showSnapshotImage;
        },
        loadChannel() {
            axios.get(this.channelApi).then((response) => {
                this.channel = response.data.data;
                // this.meta = response.data.meta;
                this.isRender = true;
                // console.log('is online : ' + this.isOnAir);
                if (this.isOnAir) {
                    this.calLiveDuration();
                }
                this.liveVideoPlayerComponent = 'vueVideoPlayer';
                this.initializeChannel();
                this.initializePusherListener();
                // this.getChattingInfo();
            });
        },
        showPlayerBroadcast({ broadcast, recordingKind }) {
            // 7일이내 방송만 재생가능하도록 한 로직 제거
            // const nowDate = moment().utc();
            // if (nowDate.subtract(6, 'day') > moment(broadcast.started_at)) {
            //     this.$toasted.error(this.$t('paragraphs.channel.download_in_7days'));
            //     return;
            // }
            this.isPlayerModalOpen = true;

            if (this.liveVideoPlayer) {
                this.$store.dispatch('setPlayerSnapshot', { muted: this.liveVideoPlayer.muted() });
                this.liveVideoPlayer.muted(true);
            }
            this.broadcast = broadcast;
            this.recordingKind = recordingKind;
            this.recordingFiles = this.broadcast.liveMediaRecordingFiles[recordingKind];
            this.playingFiles = this.recordingFiles;
            this.broadcastVideoPlayerComponent = 'vueVideoPlayer';

            $('#playerModal').modal({});
        },
        getDuration(started) {
            const startedUtc = this.$moment.utc(started);
            const nowDate = this.$moment().utc();
            let diff = nowDate.format('X') - startedUtc.format('X');
            // const days = Math.floor(diff / (24 * 60 * 60));
            // if (days > 0) {
            //     diff %= (24 * 60 * 60);
            // }
            const hours = Math.floor(diff / (60 * 60));
            const hoursStr = (hours < 10) ? `0${hours}` : hours;
            if (hours > 0) {
                diff %= (60 * 60);
            }
            const minutes = Math.floor(diff / 60);
            const minutesStr = (minutes < 10) ? `0${minutes}` : minutes;
            if (minutes > 0) {
                diff %= (60);
            }
            const seconds = diff;
            const secondsStr = (seconds < 10) ? `0${seconds}` : seconds;
            // if (days > 0) {
            //     return `${days}d ${hoursStr}:${minutesStr}:${secondsStr}`;
            // }

            return `${hoursStr}:${minutesStr}:${secondsStr}`;
        },
        calLiveDuration() {
            const started = this.channel.latest_live_media_broadcast.started_at;

            this.durationRepeat = setInterval(() => {
                this.broadcastDuration = this.getDuration(started);
                // if (!this.isOnAir) {
                //     this.broadcastDuration = '';
                //     clearTimeout(this.durationRepeat);
                // }
            }, 1000);
        },
        renderRealTimeChartUpdate(dateStr) {
            return (dateStr !== '') ? this.$t('paragraphs.last_updated_date', { date: this.$moment.unix(dateStr).format('YYYY-MM-DD HH:mm:ss') }) : '';
        },
        loadChart() {
            this.realTimeData.loading = true;
            this.getRealTimeChartData();
        },
        getRealTimeChartData() {
            const nowDate = this.$moment().utc();
            const endedDate = nowDate.format('YYYY-MM-DD HH:mm:00');
            const startedDate = nowDate.subtract(12, 'hour').format('YYYY-MM-DD HH:mm:00');
            // const endedDate = nowDate.format('YYYY-MM-DD HH:') + (Math.floor(nowDate.format('mm') / 5) * 5) + ':00';
            // const startedDate = nowDate.subtract(12, 'hour').format('YYYY-MM-DD HH:') + (Math.floor(nowDate.format('mm') / 5) * 5) + ':00';
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/realtime/${this.selectedChannel}/${this.channel.latest_live_media_broadcast.id}` +
                `?started_at=${startedDate}&ended_at=${endedDate}&interval=${this.realTimeInterval}`;

            axios.get(apiLoc).then((response) => {
                this.realTimeData.labels = response.data.labels;
                this.realTimeData.results.count = response.data.countData;
                this.realTimeData.results.accUser = response.data.accUserData;
                this.realTimeData.results.curUser = response.data.curUserData;
                this.realTimeData.results.traffic = response.data.trafficData;
                this.realTimeData.created = this.$moment().format('X');
                this.realTimeData.loading = false;
            }).catch((error) => {
                this.realTimeData.loading = false;
                console.log(error);
                this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
        paddingChatData(chartData) {
            if (chartData.trafficData.length > 0) {
                if (chartData.trafficData[0] === 0 && chartData.accUserData[0] === 0 && chartData.curUserData[0] === 0 && chartData.countData[0] === 0) {
                    // remove first item
                    chartData.labels = _.drop(chartData.labels, 1);
                    chartData.trafficData = _.drop(chartData.trafficData, 1);
                    chartData.accUserData = _.drop(chartData.accUserData, 1);
                    chartData.curUserData = _.drop(chartData.curUserData, 1);
                    chartData.countData = _.drop(chartData.countData, 1);
                }
            }
            if (chartData.trafficData.length > 0) {
                const lastIndex = chartData.trafficData.length - 1;
                if (chartData.trafficData[lastIndex] === 0 && chartData.accUserData[lastIndex] === 0 && chartData.curUserData[lastIndex] === 0 && chartData.countData[lastIndex] === 0) {
                    // remove last item
                    chartData.labels = _.dropRight(chartData.labels, 1);
                    chartData.trafficData = _.dropRight(chartData.trafficData, 1);
                    chartData.accUserData = _.dropRight(chartData.accUserData, 1);
                    chartData.curUserData = _.dropRight(chartData.curUserData, 1);
                    chartData.countData = _.dropRight(chartData.countData, 1);
                }
            }
            return chartData;
        },
        getRealTimeChartUpdated(chartData) {
            const dataMaxCount = 146;

            if (typeof chartData.labels === 'undefined' || chartData.labels.length === 0) {
                return;
            }
            chartData = this.paddingChatData(chartData);
            const firstLabel = chartData.labels[0];

            const labelLength = this.realTimeData.labels.length;
            let firstIndex = -1;
            if (labelLength > 0) {
                for (let i = labelLength - 1; i >= 0; i -= 1) {
                    if (this.$moment(this.realTimeData.labels[i]) <= this.$moment(firstLabel)) {
                        firstIndex = i;
                        break;
                    }
                }
            }
            if (firstIndex > -1) {
                this.realTimeData.labels = _.concat(_.slice(this.realTimeData.labels, 0, firstIndex), chartData.labels);
                this.realTimeData.results.count = _.concat(_.slice(this.realTimeData.results.count, 0, firstIndex), chartData.countData);
                this.realTimeData.results.accUser = _.concat(_.slice(this.realTimeData.results.accUser, 0, firstIndex), chartData.accUserData);
                this.realTimeData.results.curUser = _.concat(_.slice(this.realTimeData.results.curUser, 0, firstIndex), chartData.curUserData);
                this.realTimeData.results.traffic = _.concat(_.slice(this.realTimeData.results.traffic, 0, firstIndex), chartData.trafficData);

                const startIndex = this.realTimeData.labels.length - dataMaxCount;
                if (startIndex > 0) {
                    this.realTimeData.labels = _.slice(this.realTimeData.labels, startIndex);
                    this.realTimeData.results.count = _.slice(this.realTimeData.results.count, startIndex);
                    this.realTimeData.results.accUser = _.slice(this.realTimeData.results.accUser, startIndex);
                    this.realTimeData.results.curUser = _.slice(this.realTimeData.results.curUser, startIndex);
                    this.realTimeData.results.traffic = _.slice(this.realTimeData.results.traffic, startIndex);
                }
                this.realTimeData.created = this.$moment().format('X');
            }
        },
        changeDuplicateRecordingState() {
            if (this.duplicateRecordingState === 'stopped') {
                // start
                const confirmMessage = this.$t('paragraphs.message.confirm.start_duplicate_recording_file');
                if (confirm(confirmMessage)) {
                    this.duplicateRecordingState = 'ing';
                    axios.post(this.duplicateRecordingApi).then((response) => {
                        this.duplicateRecordingState = 'started';
                    }).catch((error) => {
                        this.duplicateRecordingState = 'stopped';
                        if (typeof error.response.data.errors === 'undefined' && typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                            this.$toasted.error(error.response.data.message);
                        } else {
                            self.$toasted.error(this.$t('paragraphs.message.error.change'));
                        }
                    });
                }
            } else {
                // stop
                const confirmMessage = this.$t('paragraphs.message.confirm.stop_duplicate_recording_file');
                if (confirm(confirmMessage)) {
                    this.duplicateRecordingState = 'ing';
                    axios.delete(this.duplicateRecordingApi).then((response) => {
                        this.duplicateRecordingState = 'stopped';
                    }).catch((error) => {
                        this.duplicateRecordingState = 'started';
                        if (typeof error.response.data.errors === 'undefined' && typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                            this.$toasted.error(error.response.data.message);
                        } else {
                            self.$toasted.error(this.$t('paragraphs.message.error.change'));
                        }
                    });
                }
            }
        },
        doDownloadRecordingFile(recordingFile) {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}/recording-files/${recordingFile.id}/download`;
        },
        doDestroyRecordingFile(recordingFile) {
            if (!this.haveManagerRight) {
                return;
            }
            if (confirm(this.$t('paragraphs.message.confirm.remove_recording_file'))) {
                const selectedRecordingFileIds = [recordingFile.id];
                axios.delete(`/cms/${this.selectedServiceAccount.key}/recording-files`, { data: { selected_ids: selectedRecordingFileIds } }).then(() => {
                    this.$toasted.success(this.$t('paragraphs.message.success.remove_recording_file'));
                    this.loadBroadcast();
                    this.$refs.broadcasts.reload();
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.remove_recording_file'));
                    logger.error(error.response.data.errors);
                });
            }
        },
        loadBroadcast() {
            axios.get(`${this.channelApi}/broadcasts/${this.broadcast.id}`).then((response) => {
                this.broadcast = response.data.data;
                this.recordingFiles = this.broadcast.liveMediaRecordingFiles[this.recordingKind];
                if (this.recordingFiles.length === 0) {
                    $('#playerModal').modal('hide');
                    return;
                }
                this.playingFiles = this.recordingFiles;
                // this.$refs.broadcastVideoPlayer.mediainfo = this.recordingFiles;
                // this.$refs.broadcastVideoPlayer.initVodPlayer();
            });
        },
        playRecordingFile(recordingFile) {
            this.playingFiles = recordingFile;
            // this.$refs.broadcastVideoPlayer.mediainfo = recordingFile;
            // this.$refs.broadcastVideoPlayer.initVodPlayer();
        },
        getHumanReadableFilesize(filesize) {
            const transGiga = filesize / 1024 / 1024 / 1024;

            return `${Math.round(transGiga * 1000) / 1000}`;
        },
    },
    computed: {
        ...mapGetters([
            'getPusher',
        ]),
        selectedChannel() {
            return this.channel_id;
        },
        getChartWidth() {
            return (window.innerWidth - 320);
        },
        liveVideoPlayer() {
            return this.$refs.liveVideoPlayer.player;
        },
        broadcastVideoPlayer() {
            return this.$refs.broadcastVideoPlayer.player;
        },
        channelApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}`;
        },
        useRecordingFilePolicy() {
            return (this.channel.recording_file_policy === ChannelConfig.RECORDING_FILE_POLICY.ONLY_MANUAL ||
                this.channel.recording_file_policy === ChannelConfig.RECORDING_FILE_POLICY.BOTH);
        },
        duplicateRecordingApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}/broadcasts/${this.channel.latest_live_media_broadcast.id}/duplicate_recording`;
        },
        currentDuplicateRecordingState() {
            if (this.isOnAir &&
                this.channel.latest_live_media_broadcast.duplicate_recording_state.type === 'DUPLICATE_RECORDING_STARTED'
            ) {
                return 'started';
            }
            return 'stopped';
        },
        chattingStartedDate() {
            if (typeof this.channel !== 'undefined' && 'latest_live_media_broadcast' in this.channel &&
                !_.isEmpty(this.channel.latest_live_media_broadcast.chatting_started_at)) {
                return this.$moment(this.channel.latest_live_media_broadcast.chatting_started_at).utc().format('YYYY-MM-DD HH:mm:ss');
            }
            return '';
        },
        loadedChannel() {
            return this.loadedServiceAccount && !_.isEmpty(this.selectedChannel);
        },
    },
    watch: {
        loadedChannel(newValue) {
            if (newValue) {
                this.initialize();
            }
        },
        isOnAir(newValue) {
            if (this.durationRepeat > 0) {
                this.broadcastDuration = '';
                clearInterval(this.durationRepeat);
                this.durationRepeat = null;
            }
            if (newValue) {
                this.calLiveDuration();
                this.loadChart();
            }
        },
        currentDuplicateRecordingState(newValue) {
            this.duplicateRecordingState = (newValue === 'started' ? 'started' : 'stopped');
        },
    },
};
</script>

<style scoped>
    .rec {
        font-weight: bold;
        font-size: 12px;
        color: RED;
        display: block;
    }
</style>
